import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { loadConfig } from '@rtvloco/platform/env';
import { validateEnv } from './config/envValidation';
import { initAppTracing } from './observability/tracing';
import { initAppRum } from './observability/rum';
import { themeManager } from '@rtvloco/theme/ThemeManager';
import '@rtvloco/theme/base.css';
import '@rtvloco/theme/light.css';
import '@rtvloco/theme/dark.css';
import './styles.css';
import '@rtvloco/ui/shell/styles';
import './i18n/config';

const PortalLoadingSkeleton = () => (
  <div className="portal-loading-skeleton">Loading SMARTTT Portal…</div>
);

async function bootstrap() {
  await loadConfig();
  themeManager.initialize();
  initAppTracing();
  initAppRum();
  // App is imported AFTER loadConfig() so that auth/config.ts module-level
  // code (portalAuthManager construction) runs with _config already populated.
  const { default: App } = await import('./App');
  validateEnv();
  ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <React.StrictMode>
      <Suspense fallback={<PortalLoadingSkeleton />}>
        <App />
      </Suspense>
    </React.StrictMode>,
  );
}

bootstrap().catch((err) => {
  const root = document.getElementById('root');
  if (root) root.textContent = String(err);
});
